module.exports = __webpack_public_path__ + "static/media/err_borroso_1.705a8a5e.png";